import React from 'react';
import { Box, Heading, Text } from '@chakra-ui/react';

import WithAnimation from '@/components/Common/WithAnimation';

import { BOY_NAME_SHORT, GIRL_NAME_SHORT, IS_BOY_FIRST } from '@/constants';
import { BG_DESKTOP_VIEW } from '@/constants/assets';
import { ENABLE_SPACE_BRIDE_GROOM } from '@/constants/feature-flags';

import useInvitation from '@/hooks/useInvitation';
import { BG_SECONDARY_TRANSPARENT } from '@/constants/colors';
import { useImaginationRoom } from '@invitato/imagination-room';

// const TEXT_SHADOW = 'rgba(12,12,12,.8)';

function LeftContent() {
  const isInvitation = useInvitation();
  const { onGetFinalContent, onGetFinalName } = useImaginationRoom();

  return (
    <Box
      bgColor="bgPrimary"
      width="calc(100% - 500px)"
      height="100%"
      pos="fixed"
      background={`url(${onGetFinalContent('BG_DESKTOP_VIEW', BG_DESKTOP_VIEW)})`}
      bgSize="cover"
      bgPos="center"
      borderRight="8px solid"
      borderRightColor="blackAlpha.400"
    >
      <Box bgColor={BG_SECONDARY_TRANSPARENT} height="100%" padding="42px">
        <WithAnimation>
          <Text color="secondaryColorText" letterSpacing="2px" fontSize="md" fontWeight="light">
            {isInvitation ? 'THE WEDDING OF' : 'WEDDING ANNOUNCEMENT'}
          </Text>
        </WithAnimation>
        <Box
          padding="32px 0"
          textColor="secondaryColorText"
          textTransform="uppercase"
          letterSpacing="4px"
        >
          <Heading fontWeight="normal" size="4xl">
            {IS_BOY_FIRST
              ? onGetFinalName('groomName', BOY_NAME_SHORT)
              : onGetFinalName('brideName', GIRL_NAME_SHORT)}{' '}
            &
          </Heading>
          <Heading
            fontWeight="normal"
            size="4xl"
            marginTop={ENABLE_SPACE_BRIDE_GROOM ? '-8px' : '-24px'}
            marginLeft="12px"
          >
            {IS_BOY_FIRST
              ? onGetFinalName('brideName', GIRL_NAME_SHORT)
              : onGetFinalName('groomName', BOY_NAME_SHORT)}
          </Heading>
        </Box>
        <WithAnimation>
          <Text
            color="secondaryColorText"
            fontWeight="light"
            fontStyle="italic"
            maxWidth="800px"
            letterSpacing="1px"
          >
            {`"So they are no longer two, but one flesh. Therefore what God has joined together, let no one separate."`}
            <br />— Matthew 19:6
          </Text>
        </WithAnimation>
      </Box>
    </Box>
  );
}

export default LeftContent;
